module.exports = __webpack_public_path__ + "static/img/测试.4c0fe015.png";